import {
    RestDataResponseTrialEligibilityResponse,
    UsedCarTrialRequest,
    usedCarEligibilityCheckPost,
} from '@cecm-microservices-sdk/core/services/trial/used-car-eligibility-check';
import { getMicroservicesClient } from '@/services/microservices/client';

export type MicroservicesCountryCode = 'us' | 'ca';
const GEO_COOKIE_NAME = 'sxm_geo';

function getCookiesByName(name: string): string[] {
    if (typeof document === 'undefined') {
        return [];
    }

    return document.cookie
        .split('; ')
        .map((cookie) => cookie.trim())
        .filter((cookie) => cookie.startsWith(`${name}=`))
        .map((cookie) => decodeURIComponent(cookie.split('=').slice(1).join('=')));
}

export function getMicroservicesCountryCode(): MicroservicesCountryCode {
    const geos = getCookiesByName(GEO_COOKIE_NAME);
    const isCanadianUser = geos.some((geo) => geo.endsWith(':CA'));

    return isCanadianUser ? 'ca' : 'us';
}

export async function submitUsedCarEligibilityRequest(
    countryCode: MicroservicesCountryCode,
    payload: UsedCarTrialRequest,
): Promise<RestDataResponseTrialEligibilityResponse> {
    const client = getMicroservicesClient(countryCode);

    if (!client.baseUrl) {
        throw new Error(
            `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
        );
    }

    return usedCarEligibilityCheckPost(client, payload);
}
